module.exports = __webpack_public_path__ + "img/71.d36c88d0.png";